export default __webpack_public_path__ + "static/media/pic5.053874e5.png";